export const endpoints = {
  getCSEntries: entryCode => `/${entryCode}/entries`
};
